import { trackEvent } from 'integrations/metrics';
import { EventNames } from 'integrations/metrics/events';
import { EventAction, EventObjectType } from 'integrations/metrics/types';

import { TFaqNote } from 'routes/book/Faq';

import { formatCurrency } from 'utils/helpers';

export const generateFaqNotes = (
  businessName: string,
  cancellationFee: number,
  totalDeposit = 0,
): TFaqNote[] => {
  let faqNotes = [
    {
      id: 1,
      title: "What happens if I'm a no-show or cancel?",
      text: `${businessName} has a
        ${cancellationFee}%
        cancellation policy that may be applied. Please provide as
        much notice as possible if you are unable to make it.`,
    },
    {
      id: 2,
      title: 'Will I be charged before the service?',
      text: `No, you will not be charged now. You are only reserving your
        appointment and you will pay in person after the appointment is
        finished.`,
    },
  ];

  if (totalDeposit > 0) {
    faqNotes = [
      {
        id: 1,
        title: "What happens if I'm a no-show or cancel?",
        text: `You will lose your ${formatCurrency(totalDeposit, 'USD')} deposit
          and may also be charged a cancellation fee. ${businessName} has a
          ${cancellationFee}% cancellation policy that
          may be applied. The cancellation fee is calculated on the total appointment value.
          Please provide as much notice as possible if you are unable to make it.`,
      },
      {
        id: 2,
        title: 'Will I be charged before the service?',
        text: `You will be charged a
          ${formatCurrency(totalDeposit, 'USD')} deposit upon booking
          your appointment. The deposit is non-refundable. The amount of your deposit
          will be applied to the cost of your service at the time of your appointment.
          If you need to cancel, you will lose your deposit and an additional cancellation
          fee may apply.`,
      },
      {
        id: 3,
        title: 'Will I get my deposit back?',
        text: `No. The deposit is non-refundable. The amount of your deposit will be applied
          to the cost of your service at the time of your appointment. If you need to cancel,
          you will lose your deposit and an additional cancelation fee may apply.`,
      },
    ];
  }

  return faqNotes;
};

export const trackViewPayDeposit = (depositAmount = 0) =>
  trackEvent(EventNames.PAY_DEPOSIT, {
    action: EventAction.VIEW,
    productSection: 'Manage Booking',
    productSubSection: '',
    objectType: EventObjectType.PAGE,
    depositAmount,
  });

export const trackPayDeposit = (depositAmount: number, clientFee: number) =>
  trackEvent(EventNames.PAY_DEPOSIT_SUCCESS, {
    action: EventAction.PAY,
    productSection: 'Manage Booking',
    productSubSection: 'Pay Deposit',
    objectType: EventObjectType.PAGE,
    depositAmount,
    clientFee,
  });
